module.exports = __webpack_public_path__ + "static/media/bannerIcf.a76c3347.jpg";